var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRazhodiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.84,10.6V3.42l3.35,3.35l1.22-1.27L11.92,0L6.43,5.49l1.39,1.27l3.35-3.35v7.19H0.56V24h22.88V10.6H12.84z  M21.77,19.09c0,0-1.23,0.15-2.23,1.12c-1,0.97-1.12,2.23-1.12,2.23H5.02c0,0,0.2-1.14-0.56-2.23c-0.76-1.09-2.23-1.12-2.23-1.12 v-3.35c0,0,1.41-0.14,2.23-1.12c0.82-0.98,0.56-2.23,0.56-2.23h13.4c0,0,0.23,1.29,1.12,2.23c0.88,0.94,2.23,1.12,2.23,1.12V19.09z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,14.62c-1.54,0-2.79,1.25-2.79,2.79c0,1.54,1.25,2.79,2.79,2.79c1.54,0,2.79-1.25,2.79-2.79 C14.79,15.87,13.54,14.62,12,14.62z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRazhodiIcon);
export default __webpack_public_path__ + "static/media/razhodi_icon.96262818.svg";
export { ForwardRef as ReactComponent };